<template>
  <v-dialog
    v-model="isShowModal"
    persistent
    max-width="800px">
    <v-card>
      <material-card
        :title="storeChannelId ? $t('portal.emailDomain.update') : $t('portal.emailDomain.add')"
        tile
        color="green"
        full-width
      >
        <v-container grid-list-xl>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation>
            <v-layout wrap>
              <!-- Name -->
              <v-flex
                xs12
                md6>
                <v-text-field
                  :rules="[ruleRequiredValue]"
                  v-model="name"
                  :label="'Tên'"
                  :name="'Tên'"
                  type="text"
                  class="required"
                />
              </v-flex>
              <v-flex
                xs12
                md6>
                <v-autocomplete
                  :rules="[ruleRequiredValue]"
                  :items="storeChannelsTypeList"
                  v-model="storeChannelType"
                  :label="'Kênh'"
                  class="required"
                >
                  <template
                    slot="selection"
                    slot-scope="data">
                    {{ $t(data.item.text) }}
                  </template>
                  <template
                    slot="item"
                    slot-scope="data">
                    {{ $t(data.item.text) }}
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </material-card>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          color="error darken-1"
          @click="onCloseModal"
        >{{ $t("common.close") }}
        </v-btn>
        <v-btn
          small
          color="success darken-1"
          @click="onConfirm"
        >{{ $t("common.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ToastType from 'enum/toastType'
import functionUtils from 'utils/functionUtils'
import validationRules from 'utils/validationRules'
import stringUtils from 'utils/stringUtils'
export default {
  data: () => ({
    code: null,
    isShowModal: false,
    name: null,
    storeChannelId: null,
    valid: false,
    storeChannelsTypeList: stringUtils.StoreChannelsTypeList,
    storeChannelType: null
  }),
  computed: {
    ...mapGetters([
      'GET_SNACK_BAR'
    ])
  },
  methods: {
    ruleRequiredValue (value) {
      return validationRules.ruleRequiredValue(value)
    },
    /**
     * Confirm
     */
    onConfirm: function () {
      if (this.$refs.form.validate()) {
        let filter = {
          name: this.name,
          type: this.storeChannelType
        }
        if (this.storeChannelId) {
          this.UPDATE_STORE_CHANNEL({ id: this.storeChannelId, ...filter })
            .then(
              function () {
                this.$emit('createStoreChannelSuccess')
                this.isShowModal = false
              }.bind(this)
            )
            .catch(
              function (error) {
                this.ON_SHOW_TOAST({
                  message: this.$t(functionUtils.errorResponse(error.response)),
                  styleType: ToastType.ERROR
                })
              }.bind(this)
            )
        } else {
          this.CREATE_STORE_CHANNEL(filter)
            .then(
              function () {
                this.$emit('createStoreChannelSuccess')
                this.isShowModal = false
              }.bind(this)
            )
            .catch(
              function (error) {
                this.ON_SHOW_TOAST({
                  message: this.$t(functionUtils.errorResponse(error.response)),
                  styleType: ToastType.ERROR
                })
              }.bind(this)
            )
        }
      }
    },
    /**
     * Show modal
     */
    onShowModal: function (storeChannelId) {
      // Reset the form validation state
      this.$refs.form.resetValidation()
      this.storeChannelId = storeChannelId
      if (this.storeChannelId) {
        this.GET_STORE_CHANNEL_DETAIL({ id: this.storeChannelId }).then(
          function (res) {
            let data = res.data
            this.name = data.name
            this.storeChannelType = data.type
          }.bind(this)
        )
      } else {
        this.code = null
        this.name = null
      }
      this.isShowModal = true
    },
    /**
     * Close modal
     */
    onCloseModal: function () {
      this.isShowModal = false
    },
    ...mapActions([
      'CREATE_STORE_CHANNEL',
      'GET_STORE_CHANNEL_DETAIL',
      'UPDATE_STORE_CHANNEL',
      'ON_SHOW_TOAST'
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal {
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.v-card {
  margin-bottom: 0px !important;
  margin-top: 21px !important;
}
:deep(.required label::after) {
  content: " *";
  color: red;
}
</style>
